import { render } from "./dash.vue?vue&type=template&id=e0261b46"
import script from "./dash.vue?vue&type=script&lang=js"
export * from "./dash.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__